import { registerHtml, TramOneComponent } from 'tram-one';
import XControl from './XControl';
import { useFilters } from '../hooks/keywords';

const html = registerHtml({
	XControl,
});

const FilterTag: TramOneComponent = ({ category, value, highlight }) => {
	const { getPrefix, getType, removeValue } = useFilters(category);

	const onRemoveSelected = () => {
		removeValue(value);
	};

	const highlightClass = highlight ? 'highlighted-tag' : 'tag';

	return html`
		<span class="FilterTag ${highlightClass} ${getType()}-${highlightClass}">
			${getPrefix()}${value}
			<XControl onselect=${onRemoveSelected} />
		</span>
	`;
};

export default FilterTag;
